import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import {
	Card,
	CardContent,
	CardDescription,
	CardHeader,
	CardTitle,
} from "@/components/ui/card";
import { Loader2, ExternalLink, AlertCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Alert, AlertDescription } from "@/components/ui/alert";

export const Route = createFileRoute("/parent/$id")({
	component: ParentPortalPage,
});

function ParentPortalPage() {
	const { id } = Route.useParams();
	const [error, setError] = useState<string | null>(null);
	const [isRedirecting, setIsRedirecting] = useState(true);

	useEffect(() => {
		const redirectToPortal = async () => {
			try {
				window.location.href = `${import.meta.env.VITE_API_URL}/api/parent-portal/${id}/portal`;
			} catch (err: any) {
				setError(err.message || "Erreur lors de l'accès au portail Stripe");
				setIsRedirecting(false);
			}
		};

		redirectToPortal();
	}, [id]);

	if (error) {
		return (
			<div className="min-h-screen flex items-center justify-center bg-gray-50 p-4">
				<Card className="max-w-md w-full">
					<CardHeader>
						<CardTitle className="flex items-center gap-2 text-red-600">
							<AlertCircle className="h-5 w-5" />
							Erreur
						</CardTitle>
						<CardDescription>
							Impossible d'accéder au portail Stripe
						</CardDescription>
					</CardHeader>
					<CardContent>
						<Alert variant="destructive">
							<AlertDescription>{error}</AlertDescription>
						</Alert>
						<div className="mt-4">
							<Button
								onClick={() =>
									(window.location.href = "https://www.revacours.com")
								}
								variant="outline"
								className="w-full"
							>
								Retour au site
							</Button>
						</div>
					</CardContent>
				</Card>
			</div>
		);
	}

	return (
		<div className="min-h-screen flex items-center justify-center bg-gray-50 p-4">
			<Card className="max-w-md w-full">
				<CardHeader>
					<CardTitle className="flex items-center gap-2">
						<ExternalLink className="h-5 w-5" />
						Redirection vers votre espace client
					</CardTitle>
					<CardDescription>
						Vous allez être redirigé vers le portail Stripe pour gérer vos
						moyens de paiement
					</CardDescription>
				</CardHeader>
				<CardContent className="flex flex-col items-center space-y-4">
					<Loader2 className="h-12 w-12 animate-spin text-primary" />
					<p className="text-sm text-gray-600 text-center">
						Redirection en cours...
					</p>
				</CardContent>
			</Card>
		</div>
	);
}
